export const ANALYTICS_SESSION_THRESHOLD = 30 * 60 * 1000 // 30 minutes
